import * as tslib_1 from "tslib";
import React from 'react';
import SvgIcon from '../../SvgIcon';
var RadioButtonChecked = function (props) { return (React.createElement(SvgIcon, tslib_1.__assign({}, props),
    React.createElement("path", { d: "M12 7c-2.76 0-5 2.24-5 5s2.24\n    5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48\n    2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52\n    2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" }))); };
RadioButtonChecked.sinouiName = 'SvgIcon';
export default RadioButtonChecked;
//# sourceMappingURL=RadioButtonChecked.js.map